'use strict';
import store from './store';
import router from '../router';

// Storeアクセスを許可するパス
// const examplePath = '/example/management';

/**
 * Storeアクセサ
 * ※Storeへのアクセスは基本的にこのアクセサを利用する。
 *   store/modulesの下に定義した個別のstoreに関してはどこからでもアクセスされると困るので、
 *   storeAccessor内の例を参考に制御する。
 * 
 * Storeメソッドの呼び出し方
 * 	- 共通モジュールの場合
 * 		- store.commit('storeMethod', args);
 * 		- store.getters['storeMethod']
 * 		※getterは[], mutationとactionは()で囲むので注意
 * 	- 個別モジュールの場合 (「モジュールファイル名(拡張子なし)/メソッド」で呼び出す)
 * 		- store.commit('moduleFileName/storeMethod', args);
 * 		- store.getters['moduleFileName/storeMethod']
 * 	※getterは[], mutationとactionは()で囲むので注意
 */
export const storeAccessor = {
	// /**
	//  * 個別にStoreを作成した場合のサンプル (消さないでください)
	//  * @param {*} args 引数
	//  */
	// storeMethod: (args) => {
	// 	if(!_allowStoreAccess(examplePath, true)){
	// 		// 許可されていない場所から呼ばれた場合はErrorをthrowする
	// 		throw Error('Illegal store access.');
	// 	}
	// 	store.commit('moduleFileName(No extension)/exampleMethod', args);
	// }

	// 共通Store
	/**
	 * 共通Store状態を初期化します。
	 */
	initCommonVuexState: () => {
		store.commit('initVuexState');
	},
	/**
	 * 認証トークンを設定します。
	 * @param {*} token トークン
	 */
	setToken: (token) => {
		store.commit('setToken', token);
	},
	/**
	 * 認証トークンを取得します。
	 * @returns 認証トークン
	 */
	getToken: () => {
		return store.getters['getToken'];
	},
	/**
	 * ユーザー情報を設定します。
	 * @param {*} user ユーザー情報
	 */
	setUser: (user) => {
		store.commit('setUser', user);
	},
	/**
	 * ユーザー情報を取得します。
	 * @returns ユーザー情報
	 */
	getUser: () => {
		return store.getters['getUser'];
	},
	/**
	 * ローディングフラグを設定します。
	 * @param {*} isLoading ローディングフラグ
	 */
	setIsLoading: (isLoading) => {
		store.commit('setIsLoading', isLoading);
	},
	/**
	 * ローディングフラグを取得します。
	 * @returns ローディングフラグ
	 */
	getIsLoading: () => {
		return store.getters['getIsLoading'];
	},
	/**
	 * ローディングオーバーレイ使用フラグを設定します。
	 * @param {*} useLoadingOverlay ローディングオーバーレイ使用フラグ
	 */
	setUseLoadingOverlay: (useLoadingOverlay) => {
		store.commit('setUseLoadingOverlay', useLoadingOverlay);
	},
	/**
	 * ローディングオーバーレイ使用フラグを取得します。
	 * @returns ローディングオーバーレイ使用フラグ
	 */
	getUseLoadingOverlay: () => {
		return store.getters['getUseLoadingOverlay'];
	}
}
//export { storeAccessor };

/**
 * ストアのアクセス許可判定
 * @param {String} allowedPath 許可するパス
 * @param {Boolean} perfectMatch true: 完全一致 (デフォルト), false: 部分一致
 * @returns アクセス許可判定 true: 許可, false: 不許可
 */
const _allowStoreAccess = (allowedPath, perfectMatch=true) => { // eslint-disable-line
	const currentPath = router.currentRoute.path;
	if(perfectMatch){
		return currentPath === allowedPath;
	} else {
		return currentPath.indexOf(allowedPath) !== -1;
	}
}